import VipPopup from '../components/VipPopup';

export default (function (w, d) {
    'use strict';

    function ProductUploadLandingController() {
        new VipPopup();
        this.initProductUploadLanding();
    }

    ProductUploadLandingController.prototype.initProductUploadLanding = function () {
        $('.goto-upload').on('click', function (e) {
            window.location.href = $(this).data('action');
        });
    }

    return ProductUploadLandingController;
}(window, document));